module.exports = __webpack_public_path__ + "img/gonetwork2_6.d1da79e5.png";